<ng-template #modal>
  <div class="popup-window edit-confirmation">
    <div class="modal-header">
      <h5 id="edit-confirm-title" class="modal-title" tabindex="-1">{{ title }}</h5>
    </div>
    <div class="modal-body">
      <p>{{ body }}</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn primary rounded-pill submit confirm" (click)="confirm()">
        {{ confirmLabel }}
      </button>
      <button type="button" class="btn secondary rounded-pill cancel pull-right dismiss" (click)="dismiss()">
        {{ dismissLabel }}
      </button>
    </div>
  </div>
</ng-template>
